const pt = {
    root: { class: 'fixed top-4 right-4 z-toast flex flex-col gap-2' },
    message: ({ props }: { props: { severity?: string } }) => ({
        class: [
            'flex items-start gap-3 px-4 py-3 rounded-8 shadow-e3 min-w-[280px] max-w-md bg-white border-l-4',
            props.severity === 'success' && 'border-l-green',
            props.severity === 'error' && 'border-l-red',
            props.severity === 'warn' && 'border-l-yellow',
            (!props.severity || props.severity === 'info') && 'border-l-blue'
        ]
    }),
    messageIcon: { class: 'flex-none w-5 h-5 mt-0.5' },
    messageContent: { class: 'flex-1 text-sm' },
    summary: { class: 'font-semibold text-ink' },
    detail: { class: 'mt-1 text-gray-600' },
    closeButton: { class: 'flex-none w-6 h-6 rounded-4 text-gray-400 hover:text-gray-700' }
}

export default pt
